import { render, staticRenderFns } from "./RelatorioJustificativaNaoAtendimentoListRoute.vue?vue&type=template&id=26e3c2a8"
import script from "./RelatorioJustificativaNaoAtendimentoListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioJustificativaNaoAtendimentoListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports